// extracted by mini-css-extract-plugin
export default {"cardCover":"card_cardCover__QzFAw"};